<template>
  <div class="footnote-display">
    <spinner v-if="showLoader"></spinner>
    <div class="row">
      <div class="col-sm-6 text pl-sm-2 mb-3 mb-sm-0">
        <div class="raised-frame">
          <div class="d-flex justify-content-between bg-background rounded-top">
            <h2 class="px-3 py-1 my-0"> {{ hebrew ? 'טקסט' : 'Text' }}</h2>
            <router-link class="search-link text-body mb-1 mx-1 px-1 rounded" to="/">
              {{ hebrew ? 'טען טקסט חדש' : 'Reload Text' }}
              <i v-if="hebrew" class="fa fa-arrow-circle-left" aria-hidden="true"></i>
              <i v-else class="fa fa-arrow-circle-right" aria-hidden="true"></i>
            </router-link>
          </div>
          <div class="text-col f-narkis bg-white p-3 rounded-bottom">
            <h3 class="source-text" v-html="formattedText" @click="handleClick"></h3>
            <button class="btn btn-primary d-none" @click="getDifferences">Get Differences</button>
            <div class="mb-4" v-for="(item, key) in comparedText" v-bind:key="key">
              <div v-for="(subitem, subkey) in item.matches" v-bind:key="subkey">
                <h3 class="d-inline" v-html="subitem.matchedText"></h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 results pr-sm-2">
        <div class="raised-frame">
          <div class="d-flex justify-content-between bg-background rounded-top">
            <h2 class="px-3 py-1 my-0">{{ hebrew ? 'אזכורים' : 'Citations' }}</h2>
            <b-form-checkbox v-model="directChecked" switch class="pt-1 px-3" id="cb-direct-search"><small>{{ hebrew ?
                'הצג רק מקורות זהים לטקסט' : 'Display only citations identical to source'
            }}</small>
            </b-form-checkbox>
          </div>
          <div v-if="data.length > 0" class="text-col bg-white p-3 rounded-bottom" id="scrollable-area">
            <div class="mb-4" v-for="(item, key) in data" v-bind:key="key">
              <small class="mb-1">
                <div class="row">
                  <a class="col-1 pasuk-number text-primary" v-bind:id="'reference-no-' + (key + 1)"
                    @click="resultClick(key)">{{ key + 1 }}</a>
                  <div class="pasuk-text f-narkis mb-1" v-html="item.text" @click="resultClick(key)"
                    v-bind:id="'heading-' + (key + 1)"></div>
                </div>
              </small>
              <div class="row" v-for="(subitem, subkey) in item.matches" v-bind:key="subkey">
                <div class="offset-1">
                  <div class="px-2 matched-text">
                    <h3 class="f-narkis d-inline" v-html="subitem.matchedText"></h3>
                    <small class="mr-1">
                      <a class="text-primary" @click="setVerse(subitem)">({{ subitem.verseDispHeb.includes('00') ?
                          subitem.verseDispHeb.slice(0, -3) : subitem.verseDispHeb
                      }})</a>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-col bg-white rounded-bottom" v-else>
            <Messages></Messages>
          </div>
          <ChapterPopup v-model="showMoreInfo"></ChapterPopup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Actions } from "@/store/stateChanges"
import ChapterPopup from "./ChapterPopup"
import $ from "jquery"
import td from "@/diff"
import Spinner from "@/components/spinner"
import Messages from "@/components/Messages"

export default {
  name: "FootnoteDisplay",
  components: { ChapterPopup, Spinner, Messages },
  data() {
    return {
      numResults: 0,
      results: [],
      showMoreInfo: false,
      comparedText: [],
      showLoader: false
    };
  },
  mounted: function () {
    if (this.$route.query.search) {
      this.showLoader = true
      this.$store.commit("SET_TEXT_FOR_API_CALL", this.$route.query.search)
      this.$store.dispatch(Actions.RUN_FOOTNOTES)
    }
    else if (this.$store.state.selectedResults.length == 0 && !this.complete) {
      this.$router.push({ name: "Search" });
    }
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew
    },
    complete: function () {
      return this.$store.state.footnotesComplete;
    },
    data: function () {
      return this.$store.state.selectedResults;
    },
    returnText: function () {
      return this.$store.state.data.allText;
    },
    formattedText: function () {
      let tempText = this.returnText;
      if (tempText) {
        var offSet = 0;
        this.data.map((obj, index) => {
          let number = index + 1;
          tempText =
            tempText.slice(0, Number(obj.startIChar) + offSet) +
            '<em id="selectedTextID-' +
            index +
            '" class="selected-text">' +
            tempText.slice(Number(obj.startIChar) + offSet);
          tempText =
            tempText.slice(
              0,
              Number(obj.endIChar) + (offSet + (index.toString().length + 47))
            ) +
            "</em>" +
            '<small id="ref-no-' +
            number +
            '" class="reference-number">[' +
            number +
            "]</small>" +
            tempText.slice(
              Number(obj.endIChar) + (offSet + (index.toString().length + 47))
            );

          if (number >= 10) {
            offSet = offSet + index.toString().length + 48 + 63;
          } else {
            offSet = offSet + index.toString().length + 48 + 61;
          }
        });

        tempText = tempText.replace(/(?:\r\n|\r|\n)/g, "<br/>");
        return tempText;
      } else {
        return "";
      }
    },
    directChecked: {
      get() {
        return this.$store.state.directMatch
      },
      set() {
        this.$store.commit('SET_DIRECT_RESULTS', !this.directChecked)
        this.$store.dispatch(Actions.RUN_FOOTNOTES)
      }
    }
  },
  watch: {
    complete: function (val) {
      if (val) {
        this.showLoader = false;
      } else {
        this.showLoader = true;
      }
    }
  },
  methods: {
    getDifferences() {
      this.comparedText = JSON.parse(
        JSON.stringify(this.$store.state.selectedResults)
      );
      this.comparedText.map(obj => {
        let orgText = obj.text;
        var bt = orgText.indexOf("<b>");
        var nt = orgText.lastIndexOf("</b>");
        var preText = orgText.substring(0, bt);
        var postText = orgText.substring(nt + 4, orgText.length);
        orgText = orgText.substring(bt, nt + 4);
        obj.matches.map(subObj => {
          let resultText = subObj.matchedText;
          var b = resultText.indexOf("<b>");
          var n = resultText.lastIndexOf("</b>");
          resultText = resultText.substring(b, n + 4);
          //reset matchedText to compared text
          let diff = td.check(orgText, resultText);
          subObj.matchedText = preText + diff + postText;
        });
      });
    },

    setVerse(item) {
      this.$store.commit("SET_VERSE_FOR_CHAPTER", item);
      this.$store.dispatch(Actions.RUN_CHAPTERS);
      this.showMoreInfo = true;
    },
    handleClick(e) {
      let index = "";
      var data = e.target.id;
      var rightSideClicked = false;

      if (data.includes("ref-no-")) {
        rightSideClicked = true;
        index = data.replace("ref-no-", "");
      }
      if (data.includes("selectedTextID")) {
        index = data.replace("selectedTextID-", "");
        index = Number(index) + 1;
        rightSideClicked = true;
      }
      if (rightSideClicked) {
        $(".text em").removeClass("selected");
        $(".pasuk-text").removeClass("selected");

        document
          .getElementById("reference-no-" + index)
          .scrollIntoView({ behavior: "smooth", block: "start" });
        $("#heading-" + index).addClass("selected");
        $("#selectedTextID-" + Number(index - 1)).addClass("selected");
      }
    },
    resultClick(index) {
      let key = index + 1;
      $(".text em").removeClass("selected");
      $(".pasuk-text").removeClass("selected");
      document
        .getElementById("selectedTextID-" + index)
        .scrollIntoView({ behavior: "smooth", block: "start" });
      $("#selectedTextID-" + index).addClass("selected");
      $("#heading-" + key).addClass("selected");
    }
  }
};
</script>

<style lang="scss">
.footnote-display {
  direction: rtl;
}

.reference-number {
  color: var(--primary);
  margin-right: 4px;
  font-size: 14px;
  cursor: pointer;
}

.selected-text.selected {
  background-color: #d6ecff;
  position: relative;
}

del {
  text-decoration: none;
  color: #b30000;
  background: #fadad7;
}

ins {
  background: #eaf2c2;
  color: #406619;
  text-decoration: none;
}

em {
  font-style: normal;
  display: inline;

  &:hover {
    cursor: pointer;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.rounded-top {
  direction: ltr;
}

.he .rounded-top {
  direction: rtl;
}

.promotions-displayed {
  .footnote-display .text-col {
    height: calc(100vh - 245px);
  }
}

.footnote-display {
  .offset-1 {
    margin-right: 8.4%;
    margin-left: 0;

    .matched-text {
      position: relative;

      &::before {
        position: absolute;
        content: '';
        background: #d8d8d8;
        width: 2px;
        right: 0;
        top: 0;
        height: 100%;
      }
    }
  }

  .text-col {
    height: calc(100vh - 215px);

    @media screen and (max-width: 767px) {
      height: auto !important;
    }

    direction: rtl;
    text-align: right;
    overflow-y: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;

    /* IE 10+ */
    &::-webkit-scrollbar {
      width: 0px;
      background: transparent;
      /* Chrome/Safari/Webkit */
    }

    .pasuk-text {
      max-width: 90%;

      &.selected {
        background-color: #d6ecff;
        border-top-left-radius: 2px;
        border-bottom-right-radius: 2px;
        position: relative;
        padding-left: 4px;

        &::before {
          content: '';
          position: absolute;
          height: 100%;
          width: 4px;
          right: -4px;
          background-color: #d6ecff;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }

    h3.source-text {
      line-height: 1.5rem;
      text-align: right;
      direction: rtl;
    }
  }
}
</style>
